import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Paginator } from "primereact/paginator";

class ShipManagementCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
    };
  }
  render() {
    const { pageSize, totalRecords, currentPage, arraylist } = this.props;

    return (
      <div className="pb-3" style={{ marginTop: "12px" }}>
        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          <div className="custom-paginator">
            <Paginator
              first={this.state.first}
              rows={pageSize}
              totalRecords={totalRecords}
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          </div>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No Items to Display --!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, eyeclick } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          // <div className="card" style={{ overflow: "hidden", position: "relative", marginTop: "2px" }}>
          //   <div className="p-3">
          //     <div className="resource-list-auth-date">
          //       <div className="row">
          //         <div className={"col-md-11 col-sm-10 col-10 col-m-auto"}>
          //           <div className="row px-3">
          //             <div className={showSidePane ? "col-sm-12 mb-1" : "col-sm-12 mb-2"}>
          //               <h6 className="resource-list-title m-auto" >{item.shipName} </h6>
          //             </div>
          //             <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-2"}>
          //               <span><strong>IMO No : </strong><span className="italicFont ">{item.imoNo} </span></span>
          //             </div>
          //             <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-3"}>
          //               <span><strong>Mail ID : </strong><span className="italicFont ">{item.mail} </span></span>
          //             </div>
          //             <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-7"}>
          //               <span><strong>Ship Management Company Mail Id : </strong><span className="italicFont ">{item.shippingCompanyMail} </span></span>
          //             </div>
          //           </div>
          //         </div>
          //         <div className={"col-sm-2 col-md-1 col-m-auto col-2"}>
          //           <div className={showSidePane ? "vertical-center" : "vertical-center"} >
          //             <i className="fa fa-eye fa-2x click" onClick={() => eyeclick(item)} aria-hidden="true" style={{ color: ' #1a3464', marginLeft: '-15px' }}></i>
          //           </div>
          //         </div>
          //       </div>
          //     </div>
          //   </div>
          // </div>
          <div className="card" style={{ overflow: "hidden", position: "relative", marginTop: "2px" }}>
            <OverlayTrigger
              placement="left-start"
              delay={{ show: 250, hide: 400 }}
              overlay={null}
            >
              {/* <div className="arrow-left-red1"></div> */}
              <div className={item?.isActive ? "arrow-left-green" : 'arrow-left-red1'}></div>
            </OverlayTrigger>
            {/* <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={"col-md-11 col-sm-11 col-11 col-m-auto"}>
                    <div className="row px-2">
                      <div className="col-lg-3 col-md-3 col-sm-12 col-12 ">
                        <div className="row g-0">
                          <div className={showSidePane ? "col-sm-12 mb-1" : "col-sm-12 mb-2"}>
                            <h6 className="resource-list-title m-auto" >{item.shipName} </h6>
                          </div>
                          <div className={showSidePane ? "col-sm-12 mb-1" : "col-sm-12"}>
                            <span><strong>IMO No : </strong><span className="italicFont ">{item.imoNo} </span></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-12 col-12 ">
                        <div className="row g-0">
                          <div className={showSidePane ? "col-12 mb-1" : "col-12 mb-2"}>
                            <span><strong>Mail ID : </strong><span className="italicFont ">{item.mail} </span></span>
                          </div>
                          <div className={showSidePane ? "col-sm-12 mb-1" : "col-sm-12"}>
                            <span><strong>Status : </strong><span className="italicFont ">{item?.isActive ? 'Active' : 'Inactive'}</span></span>
                          </div>
                        </div>
                      </div>

                      <div className={showSidePane ? "col-sm-6 col-12 mb-1" : "col-sm-6 "}>
                        <span><strong>Ship Management Company Mail Id : </strong><span className="italicFont ">{item.shippingCompanyMail} </span></span>
                      </div>
                    </div>
                  </div>
                  <div className={"col-sm-1 col-md-1 col-1 d-flex justify-content-end align-items-center"}>
                    <div className={showSidePane ? "vertical-cenr" : "vertical-cent"} >
                      <i className="fa fa-eye fa-2x click" onClick={() => eyeclick(item)} aria-hidden="true" style={{ color: ' #1a3464' }}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={"col-md-11 col-sm-10 col-10 col-m-auto"}>
                    <div className="row px-2">
                      <div className="col-lg-3 col-md-3 col-sm-12 col-12 ">
                        <h6 className="resource-list-title m-auto" >{item.shipName} </h6>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-12 col-12 mt-1 mt-md-0">
                        <span><strong>IMO No : </strong><span className="italicFont ">{item.imoNo} </span></span>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 col-12 mt-1 mt-md-0">
                        <span><strong>Status : </strong><span className="italicFont ">{item?.isActive ? 'Active' : 'Inactive'}</span></span>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 col-12 mt-md-3 mt-sm-1 mt-1">
                        <span><strong>Ship Email : </strong><span className="italicFont ">{item.mail} </span></span>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 col-12 mt-md-3 mt-sm-1 mt-1">
                        <span><strong>Company Email : </strong><span className="italicFont ">{item.shippingCompanyMail} </span></span>
                      </div>
                    </div>
                  </div>
                  <div className={"col-sm-2 col-md-1 col-2 d-flex justify-content-end align-items-center"}>
                    <div className={showSidePane ? "vertical-cenr" : "vertical-cent"} >
                      <i className="fa fa-eye fa-2x click" onClick={() => eyeclick(item)} aria-hidden="true" style={{ color: ' #1a3464' }}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };


}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipManagementCard)
);
